//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';
  module
    .controller('travelerController', ['$rootScope', '$scope', '$http', 'traveler', 'progressBar', 'ngDialog',
      'commonDialog', 'fileReader', 'singleSignOn',
      'commonDialogMessage', '$stateParams', '$state', 'uiGridConstants', 'agencySelectService',
      'clientSelectService', 'toastFactory', 'authService', 'socketLogin', '$timeout', '$q', 'smsStatus', 'obexRoles',
      function ($rootScope, $scope, $http, traveler, progressBar, ngDialog, commonDialog, fileReader, singleSignOn, commonDialogMessage,
        $stateParams, $state,
        uiGridConstants, agencySelectService, clientSelectService, toastFactory, authService, socketLogin, $timeout, $q, smsStatus, obexRoles) {
        const progress = progressBar.getProgressBar();
        $scope.showAllTraveler = traveler.getShowAll();
        var emailRegex =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var passwordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,})$/;
        $scope.validate = { //'valid', 'invalid', 'not-validated'
          emailValidity: 'not-validated',
          firstNameValidity: 'not-validated',
          lastNameValidity: 'not-validated',
          passwordValidity: 'not-validated',
          confirmValidity: 'not-validated',
        };

        $scope.filesToSend = [];
        $scope.isSso = false;

        let gridData;
        $scope.traveler = {
          Id: 0,
          FirstName: null,
          LastName: null,
          Email: null,
          OrganizationId: 0,
          IsAdmin: false,
          AccountEnabled: false,
          DisableSMS: false,
          AllowAgentAccess: false,
          Phone: null,
          CustomerAccountNumber: null,
          Password: null,
          TripLinkEmail: null,
        };
        $scope.isUpdate = false;
        $scope.searchKeyword = '';
        $scope.edit = function () {
          $state.go('app.editTraveler', {
            id: $scope.rowSelectingId,
          });
        };
        $scope.searchTravelers = function () {
          traveler.setShowAll($scope.showAllTraveler);
          setGridData();
        };
        $scope.chatAppName = clientSelectService.getSelectedClient().ChatAppName
        //Call this code while edit traveler
        let id = $stateParams.id;
        if (!!id) {
          $scope.isUpdate = true;
          getTravelerById(id);
        };

        const userRole = authService.getLoginMember().Role;

        // ui-grid code
        // ui-grid options
        const gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: false,
          enableGridMenu: true,
          paginationPageSize: 25,
          useExternalPagination: true,
          useExternalSorting: false,
          enableColumnResizing: true,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          exporterMenuPdf: false,
          exporterMenuCsv: false,
          multiSelect: false,
          paginationPage: 1,
          columnDefs: [{
            headerCellTemplate: '<div></div>',
            field: 'SMS',
            enableHiding: false,
            enableSorting: true,
            enableFiltering: false,
            enableColumnResizing: false,
            exporterSuppressExport: true,
            maxWidth: 50,
            cellTemplate: '<span ng-show="grid.appScope.chatAppName === \'OWA\' '+ ' && row.entity.Phone !== null && ' + obexRoles.roleTravelManager + ' != ' + userRole + ' && ' + obexRoles.roleObexAdmin + ' != ' + userRole + '" style="padding-left: 2px;"><button class=" btn smsBtn" angular-ripple title="SMS traveler" ng-click="grid.appScope.cellClicked(row,col)" ><i class="fa fa-comment"></i></button></span> <span ng-show="grid.appScope.chatAppName !== \'OWA\' || row.entity.Phone === null || ' + obexRoles.roleTravelManager + ' == ' + userRole + ' || ' + obexRoles.roleObexAdmin + ' == ' + userRole + '" style="padding-left: 2px;"><button class=" btn smsBtn smsBtnDisable" angular-ripple title="{{grid.appScope.chatAppName !== \'OWA\' && row.entity.Phone !== null ? \'Chat is not allowed\' : \'Traveler phone is required\'}}">' + '<i class="fa fa-comment"></i></button></span>',
          }, {
            name: 'FirstName',
            enableHiding: false,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
            sort: {
              direction: uiGridConstants.ASC,
              priority: 0,
            },
          }, {
            name: 'LastName',
            displayName: 'Last Name',
            enableHiding: false,
            enableFiltering: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Email',
            visible: true,
            enableHiding: true,
            enableFiltering: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Phone',
            visible: true,
            displayName: 'Phone',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'IsAdmin',
            displayName: 'Admin Access',
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'AccountEnabled',
            displayName: 'Account Enabled',
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          },],
          rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
        };
        $scope.gridDetails = _.cloneDeep(gridOptions);
        $scope.gridDetails.onRegisterApi = function (gridApi) {
          $scope.gridApi = gridApi;

          // Row Selection
          gridApi.selection.on.rowSelectionChanged($scope, function (row) {
            $scope.rowSelectingId = row.entity.Id;
            if (row.isSelected) {
              $scope.rowSelecting = true;
              if (row.entity.AccountEnabled === 'No') {
                $scope.disabledDeleteBtn = false;
              } else {
                $scope.disabledDeleteBtn = true;
              }
            } else {
              $scope.rowSelecting = false;
              $scope.disabledDeleteBtn = false;
            }
          });
          gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
            getTravelers(clientSelectService.getSelectedClient().id);
          });
        };

        $scope.onDblClick = function (row) {
          $scope.rowSelectingId = row.entity.Id;
          $scope.view();
          // Override default rowSelection action
          row.isSelected = true;
          $scope.rowSelecting = true;
        };
        let allTravelersData = [];
        function updateGridPagination(gridData, totalItems) {
          allTravelersData = gridData;
          $scope.gridDetails.data = gridData;
          $scope.gridDetails.totalItems = totalItems;
        };

        function setGridData() {
          if (authService.getLoginMember().Role === 3) {
            getTravelers(authService.getLoginMember().OrganizationId);
          } else {
            const valid = validateAgencyAndClientSelection();
            if (valid.agencyValid && valid.clientValid) {
              if (!!clientSelectService.getSelectedClient().id) {
                getTravelers(clientSelectService.getSelectedClient().id);
              }
            } else if (valid.agencyValid) {
              //toastFactory.toast_info('Please select a client.');
            } else {
              //toastFactory.toast_info('Please select an agency and then client.');
            }
          }
        };

        function setSso() {
          if (authService.getLoginMember().Role === 4) {
            const valid = validateAgencyAndClientSelection();
            if (valid.agencyValid && valid.clientValid) {
              if (!!clientSelectService.getSelectedClient().id) {
                const orgId = clientSelectService.getSelectedClient().id;
                singleSignOn.getSingleSignOnByOrganizationId(orgId).then(function (singleSignOnOrg) {
                  console.log("singleSignOnOrg: ", singleSignOnOrg);
                  $scope.isSso = true;
                }, function (err) {
                  if (err && err.statusText == 'Not Found') {
                    $scope.isSso = false;
                  } else {
                    console.log("error while validation organization is sso or not", err);
                  }
                });
              }
            }
          }
        }

        function getTravelers(id) {
          $scope.chatAppName = clientSelectService.getSelectedClient().ChatAppName
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && id) {
            progress.start();
            traveler.getTravelersByOrgId(id, $scope.gridDetails, $scope.showAllTraveler, $scope.searchKeyword).then(function (response) {
              const travelersData = response.data;
              $scope.isExportData = !!travelersData.SupportedTravelers.length ? true : false;
              let travelers = [];
              if ($scope.showAllTraveler !== true) {
                travelers = travelersData.SupportedTravelers.filter(function (traveler) {
                  return traveler.AccountEnabled;
                }).map(function (traveler) {
                  return {
                    Id: traveler.Id,
                    FirstName: traveler.FirstName,
                    LastName: traveler.LastName,
                    Phone: traveler.Phone,
                    Email: (traveler.AlternateEmail) ? traveler.AlternateEmail : traveler.Email,
                    AccountEnabled: ((traveler.AccountEnabled) ? 'Yes' : 'No'),
                    IsAdmin: ((traveler.IsAdmin) ? 'Yes' : 'No'),
                    DeviceToken: traveler.DeviceToken,
                    OSPlatform: traveler.OSPlatform
                  };
                });
              } else {
                travelers = travelersData.SupportedTravelers.map(function (traveler) {
                  return {
                    Id: traveler.Id,
                    FirstName: traveler.FirstName,
                    LastName: traveler.LastName,
                    Phone: traveler.Phone,
                    Email: (traveler.AlternateEmail) ? traveler.AlternateEmail : traveler.Email,
                    AccountEnabled: ((traveler.AccountEnabled) ? 'Yes' : 'No'),
                    IsAdmin: ((traveler.IsAdmin) ? 'Yes' : 'No'),
                    DeviceToken: traveler.DeviceToken,
                    OSPlatform: traveler.OSPlatform
                  };
                });
              }
              gridData = travelers;
              updateGridPagination(gridData, travelersData.TotalTravelers);
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`;
                    $scope.errTitle = 'Traveler Error';
                  },],
                });
              }
            })
              .finally(function () {
                progress.complete();
              });
          }
        };
        setGridData();
        setSso();
        function getTravelerById(id) {
          progress.start();
          traveler.getTravelerById(id).then(function (traveler) {
            $scope.traveler = traveler.data;
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                  $scope.errTitle = 'Get Traveler Error';
                },],
              });
            }
          })
            .finally(function () {
              progress.complete();
            });
        };
        //update First and Last Name
        function updateName(travelerContext) {
          traveler.updateName(travelerContext.Id, travelerContext).then(function (traveler) {
            const dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Edit Traveler Success';
                $scope.successMsg = 'The traveler has been updated successfully.';
              },],
            });
            dialogPost.closePromise.then(function (data) {
              $state.go('app.travelers');
            });
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                  $scope.errTitle = 'Update Traveler Error';
                },],
              });
            }
          })
            .finally(function () {
              progress.complete();
            });
        };
        //Enable Disable Account and Delete the account
        $scope.deleteAccount = function () {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Delete Traveler?';
              $scope.strMsg = 'Do you really want to delete this traveler?';
            },],
          });
          confirm.closePromise.then(function (data) {
            if ($scope.rowSelectingId && data.value === 1) {
              progress.start();
              traveler.deleteAccount($scope.rowSelectingId).then(function (del) {
                const dialogPost = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Delete Traveler Success';
                    $scope.successMsg = 'Account deleted successfully';
                  },],
                });
                dialogPost.closePromise.then(function (data) {
                  $scope.gridApi.core.clearAllFilters();
                  setGridData();
                });
              }, function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                      $scope.errTitle = 'Delete Traveler Error';
                    },],
                  });
                }
              })
                .finally(function () {
                  progress.complete();
                });
            }
          });
        };

        $scope.sendHrFeedData = function () {
          const loginUser = authService.getLoginMember();
          const isPasswordValid = passwordRegex.test($scope.password);
          const isConfirmPasswordValid = ($scope.password !== $scope.confirmPassword) ? false : true;
          const isFileUpload = $scope.filesToSend && $scope.filesToSend.length < 1 ? false : true;
          const selectedClient = clientSelectService.getSelectedClient();
          const orgId = selectedClient.id;
          const orgName = selectedClient.name;
          const isEmailValid = emailRegex.test($scope.userEmail);
          if ((!$scope.isSso && !isPasswordValid) || ($scope.userEmail && !isEmailValid) || (isFileUpload && $scope.filesToSend.length > 1) || (!$scope.isSso && !isConfirmPasswordValid) || !isFileUpload || !orgId) {
            const dialog = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '';
                if (!orgId) {
                  $scope.errMsg += '<p>Please select client.</p>';
                }
                if (!isFileUpload) {
                  $scope.errMsg += '<p>Please select .csv file.</p>';
                }
                if (isFileUpload && $scope.filesToSend.length > 1) {
                  $scope.errMsg += '<p>Please select one file at a time.</p>';
                }
                if ($scope.userEmail && !isEmailValid) {
                  $scope.errMsg += '<p>Additional email is invalid.</p>';
                }
                if (!$scope.isSso) {
                  if (!isPasswordValid) {
                    $scope.errMsg += '<p>Password must contain minimum 8 characters, and must include at least 1 uppercase letter and 1 digit.</p>';
                  }
                  if (!isConfirmPasswordValid) {
                    $$scope.errMsg += '<p>Password and Confirm Password do not match.</p>';
                  }
                }
                $scope.errTitle = 'Upload HR Errors';
              },],
            });
            dialog.closePromise.then(function (data) { });
          } else {
            const file = $scope.filesToSend[0];
            const additionalEmail = ($scope.userEmail) ? $scope.userEmail.trim() : '';
            if (file != null) {
              const successMsg = (!additionalEmail) ? loginUser.Email : `${loginUser.Email} and ${additionalEmail}`;
              const confirm = ngDialog.open({
                template: 'templates/partials/viewConfirm.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.strTitle = 'Upload HR Feed';
                  $scope.strMsg = `Travelers / Employees in csv file will be uploaded for the selected client. Log (success / error) will send to you at ${successMsg}.`;
                },],
              });
              confirm.closePromise.then(function (data) {
                if (data.value === 1) {
                  if (!$scope.isSso) {
                    const data = {
                      organizationId: orgId,
                      password: $scope.password,
                      userEmail: loginUser.Email,
                      additionalEmail: additionalEmail,
                      orgName: orgName
                    }
                    traveler.sendNonSsoInfo(file, data);
                  } else {
                    const data = {
                      organizationId: orgId,
                      userEmail: loginUser.Email,
                      additionalEmail: additionalEmail,
                      orgName: orgName
                    }
                    traveler.sendSsoInfo(file, data);
                  }
                  confirm.closePromise.then(function (data) {
                    $state.go('app.travelers');
                  });
                }
              });
            } else {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>You must select .csv file</p>`;
                  $scope.errTitle = 'Upload HR File Error';
                },],
              });
            }
          }
        };

        //Set/reset admin access to user
        function setAdmin(travelerData) {
          progress.start();
          traveler.setAdmin($scope.traveler.Id, $scope.traveler.IsAdmin).then(function (del) {
            enableAccount(travelerData);
          }, function (err) {
            progress.complete();
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                  $scope.errTitle = 'Traveler Error';
                },],
              });
            }
          });
        };
        //Enable Disable Account and Delete the account
        function enableAccount(travelerData) {
          traveler.setEnableDisableAccount($scope.traveler.Id, $scope.traveler.AccountEnabled).then(function (del) {
            updateName(travelerData);
          }, function (err) {
            progress.complete();
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText}</p>`;
                  $scope.errTitle = 'Delete Traveler Error';
                },],
              });
            }
          });
        };
        $scope.updateTraveler = function () {
          if (!!clientSelectService.getSelectedClient().id) {
            const travelerData = $scope.traveler;
            const firstNameInvalid = (!travelerData.FirstName) ? true : false;
            const lastNameInvalid = (!travelerData.LastName) ? true : false;

            if (firstNameInvalid || lastNameInvalid) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '';
                  if (firstNameInvalid) {
                    $scope.errMsg += '<p>First name must be entered.</p>';
                  }
                  if (lastNameInvalid) {
                    $scope.errMsg += '<p>Last name must be entered.</p>';
                  }
                  $scope.errTitle = 'Edit Traveler Error';
                },],
              });
            } else {
              setAdmin($scope.traveler);
            }
          } else {
            // toastFactory.toast_info('Please select client.');
          }

        };
        $scope.view = function (rowId) {
          const selectId = !!rowId ? rowId : $scope.rowSelectingId;
          if (selectId) {
            getTravelerById(selectId);
          }
          ngDialog.open({
            template: 'templates/partials/viewTraveler.html',
            className: 'ngdialog-theme-plain',
            scope: $scope,
          });
        };
        $scope.saveTraveler = function () {
          if (!!clientSelectService.getSelectedClient().id) {
            let travelerData = $scope.traveler;
            var isEmailValid = emailRegex.test(travelerData.Email);
            var isPasswordValid = passwordRegex.test(travelerData.Password);
            ((!isEmailValid) ? $scope.validate.emailValidity = 'invalid' : $scope.validate.emailValidity =
              'valid');
            ((!travelerData.FirstName) ? $scope.validate.firstNameValidity = 'invalid' : $scope.validate.firstNameValidity =
              'valid');
            ((!travelerData.LastName) ? $scope.validate.lastNameValidity = 'invalid' : $scope.validate.lastNameValidity =
              'valid');
            ((!isPasswordValid) ? $scope.validate.passwordValidity = 'invalid' : $scope.validate.passwordValidity =
              'valid');
            ((travelerData.Password !== $scope.confirmPassword) ? $scope.validate.confirmValidity = 'invalid' :
              $scope.validate.confirmValidity = 'valid');
            var emailInvalid = $scope.validate.emailValidity === 'invalid',
              firstNameInvalid = $scope.validate.firstNameValidity === 'invalid',
              lastNameInvalid = $scope.validate.lastNameValidity === 'invalid',
              passwordInvalid = $scope.validate.passwordValidity === 'invalid',
              confirmInvalid = $scope.validate.confirmValidity === 'invalid';
            if (emailInvalid || firstNameInvalid || lastNameInvalid || passwordInvalid || confirmInvalid) {
              $scope.ajaxload = false;
              var dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '';

                  if (firstNameInvalid) {
                    $scope.errMsg += '<p>First name must be entered.</p>';
                  }
                  if (lastNameInvalid) {
                    $scope.errMsg += '<p>Last name must be entered.</p>';
                  }
                  if (emailInvalid) {
                    $scope.errMsg += '<p>Email is invalid.</p>';
                  }
                  if (passwordInvalid) {
                    $scope.errMsg +=
                      '<p>Password must contain minimum 8 characters, and must include at least 1 uppercase letter and 1 digit.</p>';
                  }
                  if (confirmInvalid) {
                    $scope.errMsg += '<p>Password and Confirm Password fields do not match.</p>';
                  }
                  $scope.errTitle = 'Add Traveler Error';
                },],
              });
              dialog.closePromise.then(function (data) { });
            } else {
              progress.start();
              travelerData.OrganizationId = clientSelectService.getSelectedClient().id;
              traveler.saveTraveler(travelerData).then(function (data) {
                const dialogPost = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Add Traveler Success';
                    $scope.successMsg = 'The traveler has been created successfully.';
                  },],
                });
                dialogPost.closePromise.then(function (data) {
                  $state.go('app.travelers');
                });
              }, function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}: ${err.data}</p>`;
                      $scope.errTitle = 'Save traveler Error';
                    },],
                  });
                }
              })
                .finally(function () {
                  progress.complete();
                });
            }
          } else {
            // toastFactory.toast_info('Please select client.');
          }
        };
        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          $scope.clientId = client.id;
          $scope.clientName = client.name;
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }

        $scope.exportTravelersList = function () {
          $scope.gridDetails.data = allTravelersData;
          $scope.gridDetails.exporterCsvFilename = $scope.clientName + '_Traverlers.csv';
          $timeout(function () {
            $scope.gridApi.exporter.csvExport('all', 'all');
            updateGridPagination(allTravelersData, allTravelersData.length);
          }, 100);
        }

        $scope.cellClicked = function (row, col) {
          console.log(row.entity);
          $scope.selectedRow = row.entity;
          $scope.bookingId = null;
          $scope.devicetoken = $scope.selectedRow.DeviceToken;
          $scope.osplatform = $scope.selectedRow.OSPlatform;
          $scope.bookingType = null;
          $scope.smsText = null;
          ngDialog.open({
            template: 'templates/partials/agentInitiatedMessage.html',
            className: 'ngdialog-theme-plain',
            scope: $scope,
            closeByEscape: false,
            closeByDocument: false
          });
        };
        $scope.confirmSendSms = function () {
          const loginUser = authService.getLoginMember();
          loginUser['SupportsOrganizations'] = []
          console.log('$scope.smsText ', $scope.smsText);
          console.log('$scope.selectedRow ', $scope.selectedRow);
          $http.post('/agentsms', {
            alerttext: $scope.smsText,
            payload: {
              'aps': {
                'content-available': 1,
                'bookingId': $scope.bookingId,
                'bookingType': $scope.bookingType,
                'alertText': $scope.smsText
              }
            },
            devicetoken: $scope.devicetoken,
            osplatform: $scope.osplatform,
            agentEmail: loginUser.Email,
            agencyId: loginUser.Organization.Id,
            travelerEmail: $scope.selectedRow.Email,
            clientId: $scope.clientId,
          });
          const traveler = $scope.selectedRow;
          console.log('socketId: ', socketLogin.getSocketId());
          const handleData = {
            fromNumber: traveler.Phone,
            socketId: socketLogin.getSocketId(),
            firstName: loginUser.FirstName,
            lastName: loginUser.LastName,
            email: loginUser.Email,
            organizationId: loginUser.Organization.Id,
            loginMember: loginUser,
            smstext: $scope.smsText,
            travelAgencyId: loginUser.Organization.Id,
            travelAgencyName: loginUser.Organization.Name,
            travelAgentFirstName: loginUser.FirstName,
            travelAgentLastName: loginUser.LastName,
            travelAgentEmail: loginUser.Email,
            travelAgentId: loginUser.Id,
            topic: {
              bookingId: $scope.bookingId,
              bookingType: $scope.bookingType,
              email: traveler.Email,
              phoneNumber: traveler.Phone
            },
            travelerFirstName: traveler.FirstName,
            travelerLastName: traveler.LastName,
            travelerOrganizationName: $scope.clientName,
            travelerId: traveler.Id,
            fromDatabase: false,
            status: smsStatus.Live,
            channel: 'sms'
          };
          const data = {
            travelerNumber: traveler.Phone,
            travelerFirstName: traveler.FirstName,
            travelerLastName: traveler.LastName,
            travelerEmail: traveler.Email,
            socketId: socketLogin.getSocketId(),
            travelAgentFirstName: loginUser.FirstName,
            travelAgentLastName: loginUser.LastName,
            travelAgentEmail: loginUser.Email,
            travelAgentId: loginUser.Id,
            travelAgentOrganizationId: loginUser.Organization.Id,
            loginMemberId: loginUser.Id,
            smstext: $scope.smsText,
            topic: {
              bookingId: $scope.bookingId,
              bookingType: $scope.bookingType,
              email: traveler.Email,
              phoneNumber: traveler.Phone
            },
            travelerId: traveler.Id,
            fromDatabase: false,
            channel: 'sms'
          };
          $http.post('/agentInitiatedSms', data)
            .then(response => {
              $rootScope.$broadcast('smsHandle', handleData);
              $state.go('app.sms', {
                fromNumber: traveler.Phone,
                travelerFirstName: traveler.FirstName,
                travelerLastName: traveler.LastName,
                travelerOrganizationName: $scope.clientName,
                travelerId: traveler.Id,
                fromDatabase: false,
                status: smsStatus.Live,
                channel: 'sms',
                topic: {
                  bookingId: $scope.bookingId,
                  bookingType: $scope.bookingType,
                  email: traveler.Email,
                  phoneNumber: traveler.Phone
                },
              });
              //console.log('Post to /agentInitiatedSms ', handleData);
              //return $http.post('/handleConversation', handleData);
            }, error => {
              console.log(error);
            });
        }
        //Cancel popup changes
        $scope.cancelChanges = function () {
          ngDialog.closeThisDialog(1);
        };
        // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function () {
          return clientSelectService.getSelectedClient();
        }, function (newValue, oldValue) {
          $scope.gridDetails.data = [];
          $scope.gridDetails.totalItems = 0;
          console.log(newValue);
          console.log(oldValue);
          if (newValue.id !== oldValue.id) {
            traveler.setShowAll(false);
            $scope.showAllTraveler = false;
            setSso();
          }
          //$scope.showAllTraveler = false;
          setGridData();
        }, true);
        $scope.handleTravelerSearch = function () {
          getTravelers(clientSelectService.getSelectedClient().id);
        };
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/travelerController.js